import { PieChart as RechartPie, Pie, Cell, Sector } from "recharts";
import { BRLFormat } from "shared/helpers/BRLFormat";

interface PieChartProps {
  series: any[];
  labels?: string[];
  height?: number;
  width?: number;
  colors?: string[];
  customLabel?: any;
  innerRadius?: string | number;
  outerRadius?: string | number;
}
const renderActiveShape: React.FC<any> = (props) => {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    percent,
    value,
    name,
  } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? "start" : "end";
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  return (
    <>
      <g>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
        <path
          d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
          stroke={fill}
          fill="none"
        />
        <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 12}
          y={ey}
          textAnchor={textAnchor}
          fill="#333"
        >{`${name}`}</text>
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 12}
          y={ey}
          dy={18}
          textAnchor={textAnchor}
          fill="#999"
        >
          {BRLFormat(value)}
        </text>
      </g>
      {percent > 0 && (
        <text
          x={x}
          y={y}
          z={100}
          fill="black"
          textAnchor={x > cx ? "start" : "end"}
          dominantBaseline="central"
        >
          {`${(percent * 100).toFixed(0)}%`}
        </text>
      )}
    </>
  );
};
const PieChart: React.FC<PieChartProps> = (props) => {
  const {
    series,
    height,
    width,
    customLabel,
    innerRadius = 60,
    outerRadius = 80,
    colors = [],
  } = props;
  return (
    <RechartPie width={width} height={height}>
      <Pie
        data={series}
        cx="50%"
        cy="50%"
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        paddingAngle={3}
        label={customLabel || renderActiveShape}
        labelLine={false}
        minAngle={30}
        dataKey="value"
        isAnimationActive={false}
        blendStroke={true}
      >
        {series.map((_, index) => (
          <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
        ))}
      </Pie>
    </RechartPie>
  );
};

export default PieChart;
